import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, useMediaQuery, useTheme, Grid } from "@mui/material";

import BarekamButton, { ActionbarButtons } from "../../../components/button";
import { MessageSections } from "../../../components/message/message";
import BarekamText from "../../../components/text";
import Message from "../../../components/message";

import { Title } from "../Title/Title";

import { Wrapper } from "./styled.components";

import CardItem from "../Card/CardItem";

import { BlogPostModel } from "../../../shared/models/blogModel";

import blogService from "../../../../services/blog-service";
import Container from "../Container";

const UpdatesSection = () => {
    const navigate = useNavigate();
    const { language } = useParams();
    const [data, setData] = useState<BlogPostModel[]>();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(960));

    useEffect(() => {
        if (!data) {
            blogService.getPosts(null, 10, 0).then((posts: any) => {
                setData(posts.data || []);
            });
        }
    }, []);

    return (
        <Box
            sx={{
                textAlign: "center",
                backgroundColor: "#FFFFFF",
                width: "100%",
            }}
        >
            <Container>
                <Title>
                    <Message
                        messageKey={"updates_title"}
                        sectionId={MessageSections.MAIN}
                    />
                </Title>
                <Wrapper>
                    {data?.map((update, index) => (
                        <CardItem {...update} key={update.title + index} defaultWith />
                    ))}
                </Wrapper>
                <BarekamButton
                    type={ActionbarButtons.NEW}
                    size={"l"}
                    onClick={() => navigate(`/${language}/blog`)}
                    endIcon={<ArrowForwardIcon />}
                >
                    <BarekamText variant={"m"} fontWeight={600} align={"center"}>
                        <Message messageKey={"see_all"} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </BarekamButton>
            </Container>
        </Box>
    );
};

export default UpdatesSection;
